<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

    <!--Nav start-->
    <nav class="navbar navbar-expand-lg theme-nav fixed-top">
      <div class="container">
        <!-- <router-link class="navbar-brand" to="/chatloop"
          ><img src="../assets/images/logo.png" alt="logo" />
        </router-link> -->
        <!-- <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#mainmenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"
            ><i
              class="fa fa-align-justify"
              aria-hidden="true"
              @click="toggleNavbar('navbar')"
            ></i
          ></span>
        </button>
        <div
          class="collapse navbar-collapse"
          id="mainmenu"
          :class="responsiveNav ? 'show' : ''"
        >
          <ul class="navbar-nav ml-auto" id="mymenu">
            <li class="nav-item">
              <router-link class="nav-link" to="/chatloop/index#home"
                >Home</router-link
              >
            </li>
            <li class="nav-item dropdown" @click="toggleNavbar('blogList')">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >Blog</a
              >
              <ul
                class="dropdown-menu"
                :class="responsiveBlogList ? 'show' : ''"
              >
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blog-list"
                    >blog list</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blog-details"
                    >blog details</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blogs-leftside"
                    >leftsidebar
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blogs-rightside"
                    >rightsidebar
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/chatloop/blog-details-with-leftsidebar"
                    >details leftsidebar</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/chatloop/blog-details-with-rightsidebar"
                  >
                    details rightsidebar</router-link
                  >
                </li>
              </ul>
            </li>

            <li
              class="nav-item dropdown"
              @click="toggleNavbar('otherPagesList')"
            >
              <a
                class="nav-link dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >Other Page</a
              >
              <ul
                class="dropdown-menu"
                :class="responsiveOthePageslist ? 'show' : ''"
              >
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/sign-in"
                    >Sign In</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/sign-up"
                    >Sign Up</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/forgot-pass"
                    >Forget Password</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/thank-you"
                    >Thank You</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/review"
                    >Review</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/FAQ-page"
                    >FAQ</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/coming-soon"
                    >Coming Soon</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/download"
                    >Download</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/request"
                    >Request Demo</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/404"
                    >404</router-link
                  >
                </li>
              </ul>
            </li>
          </ul> 
        </div>-->
      </div>
    </nav>
    <!-- home section -->
    <section class="theme-bg home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
  
        <!-- <div class="row justify-content-center">
         
          <div class="col-md-4" style="text-align:center">
          <div class="text-banner">
                <img
                  src="../assets/images/text_banner.png"
                  alt="top5"
                  class="img-fluid"
                  style="width:400px"
                />
              </div>
        </div>
        </div> -->
        <div class="row justify-content-center">
          <!-- <div class="col-md-6">
            <div class="home-contain">
              <div class="fadeInLeft-land-caption">
                <h2 class="landing-caption text-white">
                  Best App Landing for all your needs.. !
                </h2>
                <p class="text-white">
                  Chatloop is perfect landing page for game , photoediting ,
                  browser or any mobile application landing page
                </p>
                <div>
                  <router-link
                    to="/chatloop/index"
                    class="btn btn-inverse mt-2 mr-3"
                    >Ltr Demo</router-link
                  >
                  <router-link to="/chatloop/rtl" class="btn btn-inverse mt-2"
                    >Rtl Demo</router-link
                  >
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-3">
           
          </div> -->
        
            
          <div class="col-md-6">
            <div class="home-right">
              <div class="mobile-slid">
                <img
                  src="../assets/images/bg-popup.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
             
              <div class="topic1">
                <router-link to="/menu1"> 
                <img @click="playsound()"
                  src="../assets/images/topic1.png"
                  alt="top3"
                  class="img-fluid"
                />
                </router-link>
              </div>
              <div class="topic2">
                <router-link to="/menu2">
                <img @click="playsound()"
                  src="../assets/images/topic2.png"
                  alt="top3"
                  class="img-fluid"
                />
                </router-link>
              </div>
              <div class="topic3">
                <router-link to="/menu3">
                <img @click="playsound()"
                  src="../assets/images/topic3.png"
                  alt="top3"
                  class="img-fluid"
                />
                </router-link>
              </div>
              <div class="topic4">
                <router-link to="/menu4">
                <img @click="playsound()"
                  src="../assets/images/topic4.png"
                  alt="top3"
                  class="img-fluid"
                />
                </router-link>
              </div>
              <div class="topic5">
                <router-link to="/menu5">
                <img @click="playsound()"
                  src="../assets/images/topic5.png"
                  alt="top3"
                  class="img-fluid"
                />
                </router-link>
              </div>
              
            
            
            </div>
          </div>
         
          <!-- <div class="col-md-3">
            <div class="photo">
                <img
                  src="../assets/images/demo/home/photo-Editing-app.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
          </div> -->
        </div>
        <div class="row justify-content-center">
         
         <div class="col-md-8" style="text-align:center">
         <div class="text-footer">
               <img
                 src="../assets/images/text-by.png"
                 alt="top5"
                 class="img-fluid"
               />
             </div>
       </div>
       </div>
      </div>
    
      <div class="love-emoji">
                <img
                  src="../assets/images/chid1.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 350px;"
                />
              </div>
          
              <div class="love-emoji2">
                <img
                  src="../assets/images/child2.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 350px;"
                />
              </div>
    </section>
    
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      text: "sss",
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
    };
  },
  mounted() {
   // this.loader();
   console.log(this.text)
  },
  methods: {
    playsound(){
      var audio = new Audio('./click.mp3');
				audio.play();
    },
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
